import { shareAttachmentActionCreators } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { IAttachment } from '@app/models/Attachment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'

export interface IShareToolbarButtonProps {
  attachment: IAttachment
  propertyId?: string
}

type ShareToolbarButtonProps = IShareToolbarButtonProps &
  typeof shareAttachmentActionCreators

export class ShareToolbarButton extends React.PureComponent<
  ShareToolbarButtonProps
> {
  public render() {
    return (
      <a
        className='lightbox-toolbar-button'
        onClick={() =>
          this.props.showShareAttachmentModal(
            this.props.attachment,
            this.props.propertyId,
          )
        }
        title='Share'
      >
        <FontAwesomeIcon icon={['fal', 'share-alt']} fixedWidth />
      </a>
    )
  }
}
